import React from "react";
import { menuNavigation } from "../../Main/actions";
// import { openCloseAccountPopOver, openCloseAppStack } from "../../Header/actions";
// import { setPopOverStatus } from "../../Header/Notificaciones/actions";

export default (dispatchCallback) => [
  {
    selector: "#trabajador_main_menu",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 1,
        hoverIndex: 1,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Trabajador</h3>
          En esta sección tendrás acceso a todo lo necesario para tus gestiones como trabajador.
          </div>
      );
    },
  },
  {
    selector: "#trabajador_siniestros",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 1,
        hoverIndex: 1,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Siniestros</h3>
          Aquí podrás ver el historial de siniestros, desde tus periodos de reposo hasta tus prestaciones económicas, y además podrás descargar tus certificados.        </div>);
    },
  },
  {
    selector: "#empresa_main_menu",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 2,
        hoverIndex: 2,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Empresa</h3>
          En esta sección encontrarás lo necesario para realizar las gestiones de las empresas que administras.
          </div>
      );
    },
  },
  {
    selector: "#empresa_select_empresa",
    content: () => (
      <div>
        <h3>Seleccionar empresas</h3>
        Selecciona la empresa con la cual quieres trabajar.
        </div>
    ),
  },
  {
    selector: "#empresa_select_sucursales",
    content: () => (
      <div>
        <h3>Lista sucursales</h3>
        Puedes filtrar por sucursal de la empresa para una información más precisa.
        </div>
    ),
  },
  {
    selector: "#empresa_datos",
    content: () => (
      <div>
        <h3>Datos empresa</h3>
        A continuación podrás ver la información en detalle de la empresa y sus sucursales.
        </div>
    ),
  },
  {
    selector: "#empresa_gestionar",
    content: () => (
      <div>
        <h3>Gestionar usuarios</h3>
        Podrás gestionar el acceso de tus trabajadores entregando roles diferenciados dependiendo de su función. Además podrás suscribirlos a distintos paquetes de notificaciones para ser notificados.
        </div>
    ),
  },
  {
    selector: "#empresa_siniestros",
    content: () => (
      <div>
        <h3>Siniestros</h3>
        Aquí encontrarás información de los siniestros de los trabajadores de la empresa, además podrás enviar denuncias y adjuntar documentación de sus prestaciones económicas.
        </div>
    ),
  },
  {
    selector: "#mi_cuenta_main_menu",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 5,
        hoverIndex: 5,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Mi cuenta</h3>
          Ahora podrás gestionar tus datos en un solo lugar. ¡Recuerda que tu cuenta y usuario son personales!
          </div>
      );
    },
  },
  {
    selector: "#mi_cuenta_mi_cuenta",
    content: () => (
      <div>
        <h3>General</h3>
        En esta sección podrás visualizar y modificar tu información. Recuerda que tus datos servirán para agilizar los procesos y/o gestiones de tu empresa.
        </div>
    ),
  },
  // TOUR GUIADO NOTIFICACIONES
  // {
  //   selector: "#mi_cuenta_notificaciones",
  //   content: () => (
  //     <div>
  //       <h3>Notificaciones</h3>
  //       En esta sección podrás configurar las notificaciones que recibirás como trabajador a través de tu correo electrónico y/o un sms a tu celular.
  //       </div>
  //   ),
  // },
  {
    selector: "#mi_cuenta_solicitudes",
    content: () => (
      <div>
        <h3>Solicitudes</h3>
        Si necesitas tener acceso para gestionar una empresa, solo debes enviar una solicitud y esperar a que el encargado de la empresa la apruebe.
        </div>
    ),
  },
  {
    selector: "#mi_cuenta_empresas_achs",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 5,
        hoverIndex: 5,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Empresas ACHS</h3>
          Los trabajadores ACHS pueden asignar empresas a su cuenta sin la necesidad de enviar solicitudes. Recuerda que la empresa no te verá como un usuario de su nómina de trabajadores.
          </div>
      );
    },
  },
  // TOUR GUIADO NOTIFICACIONES
  // {
  //   selector: "#btnNotificacion",
  //   content: () => (
  //     <div>
  //       <h3>Notificaciones</h3>
  //       Implementamos un nuevo sistema de notificaciones para mantenerte informado de tus gestiones y distintos procesos que te puedan interesar.
  //     </div >
  //   ),
  // },
  {
    selector: "#btnAppStack",
    content: () =>
      // dispatchCallback(openCloseAccountPopOver(false));
      // dispatchCallback(openCloseAppStack(true));
      (
        <div>
          <h3>Acceso único</h3>
          Desde hoy podrás acceder directamente a todos los portales desde un mismo lugar y con una misma cuenta.
        </div>
      )
    ,
  },
  {
    selector: "#btnUserInfo",
    content: () => (
      <div>
        <h3>Cerrar sesión</h3>
        Recuerda cerrar sesión cuando hayas terminado ya que la información que maneja la plataforma es confidencial.
        </div >
    ),
  },
];

